import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button',
  templateUrl: './st-button.component.html',
  styleUrls: ['./st-button.component.scss'],
  standalone: false
})
export class StButtonComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  primary: boolean = false;

  @Input()
  disabled: boolean = false;

  @Input()
  label: string = 'Button';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();

  public get classes(): string[] {
    const mode = this.primary ? 'st-button-primary' : 'st-button-secondary';
    return [mode];
  }
}
